export default __webpack_public_path__ + "static/media/resume_btn.4e24df4a.png";